import styled from '@emotion/styled';

import { Badge } from '@ssa-ui-kit/core';

const Marker = styled(Badge)`
  display: inline-block;

  padding: 0;
  margin-right: 5px;

  width: 4px;
  height: 4px;
`;

export default Marker;
